import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import {
  LandingPage,
  SignupPage,
  PricingPage,
  OnboardingPage,
  CallbackPage,
  AuthDebugPage,
  Dashboard,
  CompaniesPage,
  NotificationsPage,
  SettingsPage,
  SubscriptionPage,
} from './pages';
import MainLayout from './layouts/MainLayout';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Rotas Públicas */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/cadastro" element={<SignupPage />} />
          <Route path="/precos" element={<PricingPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/callback" element={<CallbackPage />} />

          {/* Rotas Protegidas com Layout Principal */}
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/empresas" element={<CompaniesPage />} />
            <Route path="/notificacoes" element={<NotificationsPage />} />
            <Route path="/configuracoes" element={<SettingsPage />} />
            <Route path="/assinatura" element={<SubscriptionPage />} />
            <Route path="/auth-debug" element={<AuthDebugPage />} />
          </Route>
          
          {/* Redirecionamento para rotas não encontradas */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;


